<template>
  <ui-crud title="NCRs" subtitle="Manage non-conformance reports." :fetch="fetch" :pipe-with="pipeItems">

    <!-- Filters. -->
    <template #filters="{ debouncedRefresh }">
      <div class="relative">
        <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
        <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
          <i class="fas fa-search"></i>
        </div>
      </div>
    </template>

    <!-- List item. -->
    <template #list-item="{ item, select, active }">
      <ui-crud-card
          :title="`#${item.id} ${item.title}`"
          :subtitle="item.package_name"
          :metadata="item.opened_at"
          :active="active"
          @click="select()"
      ></ui-crud-card>
    </template>

    <!-- Create form. -->
    <template #create="{ addItem }">
      <ncr-page-form :package-id="packageId" :add-item="addItem"></ncr-page-form>
    </template>

    <!-- Edit form. -->
    <template #edit="{ selectedItem, setEditMode, removeItem }">
      <ncr-page-form :package-id="packageId" :item="selectedItem" :edit="setEditMode" :remove-item="removeItem"></ncr-page-form>
    </template>

    <!-- Show page. -->
    <template #show="{ selectedItem, setEditMode, removeItem }">
      <ncr-page-show :item="selectedItem" :edit="setEditMode" :remove-item="removeItem"></ncr-page-show>
    </template>
  </ui-crud>
</template>

<script>
import { Ncr } from '@models'

export default {
  props: {
    packageId: null,
  },
  data () {
    return {
      search: '',
    }
  },
  methods: {
    async fetch () {
      return await Ncr.all(this.packageId)
    },
    pipeItems(items) {
      return items.filter(item =>
          item.title.toLowerCase().includes(this.search.toLowerCase()) ||
          `${item.id}`.toLowerCase().includes(this.search.toLowerCase())
      )
    },
  }
}
</script>
